<template>
  <div class="legislacao">
    <div class="container">
      <h1 class="display-1 primary--text my-3">Legislação</h1>
      <v-divider></v-divider>
      <v-layout wrap class="my-4">
        <v-flex xs12 md4 v-for="item in itemsLegislacao" :key="item.decreto">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 12 : 2" class="ma-2">
              <v-card-text>
                <div class="subtitle-1 primary--text">{{ item.titulo }}</div>
                <div class="subtitle-2 grey--text">{{ item.texto }}</div>
              </v-card-text>
              <v-card-actions>
                <a style="text-decoration: none" :href="item.url">
                  <v-icon left class="grey--text">move_to_inbox</v-icon>
                  <span class="grey--text">Baixar</span>
                </a>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemsLegislacao: {
      type: Array,
    },
  },
  data() {
    return {
      tituloDecreto: "",
      sinopseDecreto: "",
      linkDecreto: "",
      loading: true,
      transition: "fade-transition",
    };
  },
};
</script>
